import { render, staticRenderFns } from "./account-registration.vue?vue&type=template&id=1d369733"
import script from "./account-registration.vue?vue&type=script&lang=js"
export * from "./account-registration.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports